import './index.scss';
import React, { Component } from 'react'
import {Layout} from 'antd';
import Topbar from '../../components/menu/topbar';
import Breadcrumb from '../../components/breadcrumb';
import {withRouter} from 'react-router-dom';

const { Header, Content } = Layout;

class BaseLayout extends Component {
  render () {
    return (
      <Layout className="layout">
        <Header className="topbar">
          <Topbar />
        </Header>
        <Content>
          <div style={{ padding: '70px 50px 50px' }}>
            <Breadcrumb />
            <Content className="content">
              {this.props.children}
            </Content>
          </div>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(BaseLayout);